<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.status === 'recorded'" size="small" type="info">Rögzítve</el-tag>
      <el-tag v-if="scope.row.status === 'dropped'" size="small" type="info">Átvételre vár</el-tag>
      <el-tag v-if="scope.row.status === 'done'" size="small" type="success">Átvéve</el-tag>
      <el-tag v-if="scope.row.status === 'cancelled'" size="small" type="danger">Visszavonva</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'status',
  };
</script>
